import React, {useEffect, useRef, useState} from 'react';
import {useSelector, useDispatch} from "react-redux";
import Sidebar from "../components/Sidebar";
import Navigation from "../components/Navigation";
import {Col, Row} from "react-bootstrap";
import Footer from "../components/Footer";
import {useLocation, useNavigate} from "react-router-dom";
import PencilEdit from "../components/Icons/PencilEdit";
import Trash from "../components/Icons/Trash";
import DeleteModal from "../components/DeleteModal";
import Heading from "../components/Heading";
import DropdownItems from "../components/DropdownItems";
import status_list from "../assets/json/status.json";
import {resetDeleteDocument} from "../actions/DocumentActions";
import AlertModal from "../components/AlertModal";
import {
    deleteCertificate,
    getAllCertificate,
    resetAddCertificate, resetUploadBulkCertificates,
    uploadBulkCertificates
} from "../actions/CertificateActions";
import Loader from "../components/Loader";
import DataTable from "../components/DataTable/DataTable";
import {GrPowerReset} from "react-icons/gr";
import EmptyTable from "../assets/images/empty_certificate_table.svg"
import {decoded} from "../components/PrivateRoute";
import {getTeacherAssociates} from "../actions/ConfigActions";
import UploadModal from "../components/UploadModal";
import {resetUploadCalendarEvents, uploadEvent} from "../actions/CalendarActions";
import {getAllEvent} from "../actions/EventActions";
import ToggleSwitch from "../components/sharedUi/ToggleSwitch";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {getAllLetterTemplate} from "../actions/LetterNoticesActions";
import * as yup from "yup";

const schema = yup.object().shape({
    toggle: yup.boolean(),
});

function Certifications(props) {
    const [showDelete, setShowDelete] = useState({
        display: false,
        data: null
    });
    const history = useNavigate();
    const dispatch = useDispatch();
    const certificateRef = useRef();
    const jobTitleRef = useRef()
    const location = useLocation();
    const [alertModal, setAlertModal] = useState({
        display: false,
        type: "",
        message: ""
    });
    const [filter, setFilter] = useState(false);
    const [accessLevel, setAccessLevel] = useState(false);
    const [uploadSpreadsheet, setUploadSpreadsheet] = useState(false);
    const [importCertificates, setImportCertificates] = useState(false);
    const [teacher, setTeacher] = useState([]);
    const [certificates, setCertificates] = useState([]);
    const [record, setRecord] = React.useState();
    const [pageSize, setPageSize] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [fieldData, setFieldData] = useState({
        dataTeacher: "",
        dataType: "",
        dataStatus: "",
        showInactiveUsers: false,
        jobTitle: "",
    });
    const [formData, setFormData] = useState({
        file: "",
    });
    const {
        register,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: { toggle: false },
    });

    const columns = React.useMemo(() => [
        {
            Header: 'Teacher/Associate',
            accessor: 'associateName',
            width: "15%"
        },
        {
            Header: 'Job Title',
            accessor: 'job',
            width: "15%"
        },
        {
            Header: 'Certification',
            accessor: 'title',
            width: "10%"
        },
        {
            Header: 'From',
            accessor: 'validFromDate',
            width: "15%"
        },
        {
            Header: 'To',
            accessor: 'validToDate',
            width: "15%"
        },
        {
            Header: 'Status',
            accessor: 'statusCertificate',
            width: "10%",
            Cell: ({value}) => (value === 0 ? <span className="text-active">Valid</span> :
                value === 2 ? <span className="text-inactive">Expired</span> : (value === 3
                    ? <span className="text-inactive">Exempt/Not Required</span>
                    : <span className="text-yellow">In Progress</span>))
        },
        {
            Header: 'Notes',
            accessor: 'notes',
            width: "10%"
        },
        {
            Header: 'Action',
            id: 'actions',
            width: "10%",
            Cell: ({row}) => (
                <div className="row background-1">
                    <div onClick={() => editDoc(row.original)} className="col-4 padding-left-unset">
                        <PencilEdit className="sidebar-icon"
                                    color="var(--primary-100)"/>
                    </div>
                    <div onClick={() => showDeleteModal(row.original)} className="col-4 padding-left-unset">
                        <Trash className="sidebar-icon margin-left"
                               color="var(--red)"/>
                    </div>
                </div>
            ),
        },
    ], []);
    const columnsTeacher = React.useMemo(() => [
        {
            Header: 'Teacher/Associate',
            accessor: 'associateName',
            width: "15%"
        },
        {
            Header: 'Job Title',
            accessor: 'job',
            width: "15%"
        },
        {
            Header: 'Certification',
            accessor: 'title',
            width: "10%"
        },
        {
            Header: 'From',
            accessor: 'validFromDate',
            width: "15%"
        },
        {
            Header: 'To',
            accessor: 'validToDate',
            width: "15%"
        },
        {
            Header: 'Status',
            accessor: 'statusCertificate',
            width: "10%",
            Cell: ({value}) => (value === 0 ? <span className="text-active">Valid</span> :
                value === 2 ? <span className="text-inactive">Expired</span> : (value === 3
                    ? <span className="text-inactive">Exempt/Not Required</span>
                    : <span className="text-yellow">In Progress</span>))
        },
        {
            Header: 'Notes',
            accessor: 'notes',
            width: "20%"
        },
    ], []);

    const getCertificate = useSelector(state => state.getAllCertificate)
    const {error, loading, certificateInfo} = getCertificate

    useEffect(() => {
        if (!getCertificate.certificate_list <= 0) {
            setCertificates([])
            getCertificate.certificate_list.map((item, index) => {
                console.log(item)
                setCertificates((prevData) => [
                    ...prevData,
                    {
                        certificationId: item.certificationId,
                        associateId: item.associateId,
                        job: item.associateJobTitle,
                        associateName: item.associateName,
                        title: item.title,
                        validFromDate: item.validFromDate,
                        validToDate: item.validToDate,
                        type: item.type,
                        notes: item.notes,
                        statusCertificate: item.statusId,
                    }
                ])
            });
            if (getCertificate.records !== undefined) {
                setRecord(getCertificate.records)
            }
        }
    }, [getCertificate.certificate_list]);

    const deleteCertificateDetails = useSelector(state => state.deleteCertificate)
    const {errorDelete, loadingDelete} = deleteCertificateDetails

    const getTeacherList = useSelector(state => state.getTeacherAssociate)
    const {teacher_list} = getTeacherList

    const exportAllCertificateDetails = useSelector(state => state.exportAllCertificate)
    const {loadingCertificateExport} = exportAllCertificateDetails

    const uploadBulKCertificatesDetails = useSelector(state => state.uploadBulKCertificates)
    const {errorUpload, errorSuccess, loadingUpload, upload_certificates} = uploadBulKCertificatesDetails

    useEffect(() => {
        if (deleteCertificateDetails.certificate_delete === true) {
            dispatch(resetDeleteDocument())
            setCertificates([])
            dataTableReload()
        }
        if (deleteCertificateDetails.error) {
            setAlertModal({
                display: true,
                type: "error",
                message: "Certificate couldn't be deleted"
            })
        }
    }, [deleteCertificateDetails]);

    useEffect(() => {
        if (uploadBulKCertificatesDetails.upload_certificates === true) {
            setAlertModal({
                display: true,
                type: "success",
                message: "Certificates uploaded successfully"
            })
            dispatch(resetUploadBulkCertificates())
            setCertificates([])
            dataTableReload()
        }
        if (uploadBulKCertificatesDetails.errorSuccess === false) {
            setAlertModal({
                display: true,
                type: "error",
                message: uploadBulKCertificatesDetails.errorUpload
            })
        }
    }, [uploadBulKCertificatesDetails]);

    useEffect(() => {
        if (!getTeacherList.teacher_list <= 0) {
            setTeacher([])
            getTeacherList.teacher_list.map((item, index) => {
                setTeacher((prevData) => [
                    ...prevData,
                    {
                        id: item.employee_ID,
                        data: `${item.employee_First_Name} ${item.employee_Last_Name}`,
                    }
                ])
            });
        }
    }, [getTeacherList.teacher_list]);

    const teacherResult = (data) => {
        setFieldData({
            ...fieldData,
            dataTeacher: data.id
        })
    }

    const statusResult = (data) => {
        setFieldData({
            ...fieldData,
            dataStatus: data.id
        })
    }

    const handleToggleUpdate = (newValue) => {
        setFieldData({
            ...fieldData,
            showInactiveUsers: newValue
        })
    };

    const dataTableReload = () => {
        setCertificates([])
        dispatch(getAllCertificate(pageSize, pageNumber, fieldData.dataTeacher, certificateRef.current.value, fieldData.dataStatus, fieldData.showInactiveUsers, jobTitleRef.current.value))
    }

    useEffect(() => {
        setCertificates([])
        dataTableReload()
    }, [fieldData, pageNumber, filter]);

    useEffect(() => {
        dispatch(getTeacherAssociates())
        setAccessLevel(decoded.RoleAccessLevels)
        setCertificates([])
        if (location.state?.success) {
            setAlertModal({
                display: true,
                type: "success",
                message: "Certificate successfully added"
            })
            history('/certifications', {state: {}})
        }
    }, [])


    const pageName = 'certifications';

    const editDoc = (data) => {
        history(`/edit-certificate/${data.certificationId}`)
    }
    const showDeleteModal = (data) => {
        setShowDelete({
            display: true,
            data: data.certificationId
        })
    }
    const hideDeleteModal = (data) => {
        if (data === 1) {
            dispatch(deleteCertificate(showDelete.data))
        }
        setShowDelete({
            display: false
        })
    }

    const closeAlert = (data) => {
        setAlertModal({
            display: false
        })
        dispatch(resetAddCertificate())
    }
    const changePage = (data) => {
        setCertificates([])
        setPageNumber(data)
    }
    const resetData = (e) => {
        e.preventDefault()
        certificateRef.current.value=""
        jobTitleRef.current.value=""
        setFilter(true)
        setFieldData({
            ...fieldData,
            dataType: null,
            dataStatus: null,
            dataTeacher: null,
            showInactiveUsers: false,
            jobTitle: false,
        })
        reset({toggle: false});
        setPageNumber(1)
    }

    const handleSearch = (e) => {
        if (e.key === 'Enter') {
            setFieldData({
                ...fieldData,
                dataType: e.target.value,
            })
        }
    };

    const handleSearchJobTitle = (e) => {
        if (e.key === 'Enter') {
            setFieldData({
                ...fieldData,
                jobTitle: e.target.value,
            })
        }
    };

    const changeSearch = (e) => {
        if (e.target.value == "") {
            setFieldData({
                ...fieldData,
                dataType: certificateRef.current.value
            })
        }
    }

    const changeSearchJobTitle = (e) => {
        if (e.target.value == "") {
            setFieldData({
                ...fieldData,
                jobTitle: jobTitleRef.current.value
            })
        }
    }

    const openImport = (e) => {
        setUploadSpreadsheet(true)
    }
    const uploadDocumentResult = (data) => {
        if (data[0] === 0) {
            setUploadSpreadsheet(false)
        }
        if (data[0] === 1) {
            setUploadSpreadsheet(false)
            setFormData({
                ...formData,
                file: data[1]
            })
            setImportCertificates(true)
        }
    }
    const importResult = (data) => {
        if (data == 0) {
            setImportCertificates(false)
        }
        if (data == 1) {
            const form = new FormData();
            form.append('FormFile', formData.file);
            dispatch(uploadBulkCertificates(form))
            setImportCertificates(false)
        }
    }

    return (<>
        <Row className="sidebar-background">
            {loading && <Loader/>}
            {loadingUpload && <Loader/>}
            {loadingDelete && <Loader/>}
            {loadingCertificateExport && <Loader/>}
            {alertModal.display &&
                <AlertModal heading={alertModal.message} type={alertModal.type} result={closeAlert}/>}
            {showDelete.display && <DeleteModal heading="Delete Certificate"
                                                type="delete"
                                                question="Are you sure want to delete this Certificate?"
                                                answer=""
                                                result={hideDeleteModal}
            />}
            {uploadSpreadsheet && <UploadModal heading="Import Certificates"
                                               type="add_certificate"
                                               question="Import Certificate in bulk"
                                               answer=""
                                               result={uploadDocumentResult}
            />}
            {importCertificates && <DeleteModal heading="Import Bulk Certificates"
                                            type="import"
                                            button_true="Yes"
                                            button_false="No"
                                            question="Bulk certificates will be uploaded. Do you wish to continue?"
                                            answer=""
                                            result={importResult}
            />}
            <div className="float-left-child sidebar app-spacing">
                <Sidebar pageDetails={pageName}/>
            </div>
            <div className="float-right-child app-background app-spacing">
                <Navigation/>
                <Heading group="certificate_list" title="Certification List" result={openImport}/>
                <Row className="background-1 m-3 certificate-dropdown-group">
                    <Col lg={{span: 3}} md={{span: 3}}>
                        <DropdownItems data={teacher} title="Teacher Associate" result={teacherResult}
                                       value={fieldData.dataTeacher}/>
                    </Col>
                    <Col lg={{span: 3}} md={{span: 3}}>
                        <div className="">
                            <input
                                ref={certificateRef}
                                onKeyPress={handleSearch}
                                onChange={changeSearch}
                                type="text" autoComplete="off"
                                className="input-document input-spacing-document"
                                placeholder="Certification"
                                id="document_title"/>
                        </div>
                    </Col>
                    <Col lg={{span: 3}} md={{span: 3}}>
                        <DropdownItems data={status_list} title="Status" result={statusResult}
                                       value={fieldData.dataStatus}/>
                    </Col>
                    <Col lg={{span: 1}} md={{span: 1}}></Col>
                    <Col lg={{span: 2}} md={{span: 2}} sm={{span: 2}}>
                        <div className="float-right-child add-button button-solid reset-filter-button"
                             onClick={resetData}>
                            <GrPowerReset classname="button-icon"/> Reset
                        </div>
                    </Col>
                </Row>
                <Row className="background-1 m-3 certificate-dropdown-group">
                    <Col lg={{span: 3}} md={{span: 3}}>
                        <div className="">
                            <input
                                ref={jobTitleRef}
                                onKeyPress={handleSearchJobTitle}
                                onChange={changeSearchJobTitle}
                                type="text" autoComplete="off"
                                className="input-document input-spacing-document"
                                placeholder="Job Title"
                                id="job_title"/>
                        </div>
                    </Col>
                    <Col className="d-flex" lg={{span: 3}} md={{span: 3}}>
                        <ToggleSwitch
                            name="toggle"
                            label="Show Inactive Users"
                            register={register}
                            errors={errors}
                            setValue={setValue}
                            onUpdate={handleToggleUpdate}
                        />
                    </Col>
                </Row>

                <Row className="app-body-certificate background-1">
                    {certificates && record >= 0 && <div className="background-2">
                        <DataTable defaultPageSize={5}
                                   // filter={filter}
                                   pageSize={pageSize}
                                   columns={accessLevel != 0 ? columns : columnsTeacher}
                                   data={certificates}
                                   recordData={record}
                                   result={changePage} empty_table={EmptyTable}
                        />
                        <Footer/>
                    </div>}
                </Row>
            </div>

        </Row>
    </>);
}

export default Certifications;